<template>
  <div id="app">
    <!-- 暗黑黑金环境底色与柔和微光装饰 -->
    <div class="brand-ambient-glow glow-top"></div>
    <div class="brand-ambient-glow glow-middle"></div>
    <div class="brand-ambient-glow glow-bottom"></div>
    <div class="brand-ambient-rings"></div>
    
    <!-- 路由主视口 -->
    <div class="app-main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "@/assets/custom_theme.scss";

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #E2E8F0;
  background-color: #121214;
  background-image: 
    radial-gradient(ellipse 90% 40% at 50% -2%, rgba(229, 148, 25, 0.12) 0%, transparent 70%),
    radial-gradient(ellipse 70% 30% at 90% 40%, rgba(245, 165, 36, 0.06) 0%, transparent 60%),
    linear-gradient(180deg, #101012 0%, #151518 45%, #0E0E10 100%);
  min-height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.8);
}

/* 暗黑环境金光微晕 */
.brand-ambient-glow {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  border-radius: 50%;
  filter: blur(70px);
}

.glow-top {
  top: -80px;
  left: 50%;
  transform: translateX(-50%);
  width: 340px;
  height: 200px;
  background: radial-gradient(circle, rgba(229, 148, 25, 0.16) 0%, rgba(229, 148, 25, 0.05) 50%, transparent 75%);
}

.glow-middle {
  top: 35%;
  right: -60px;
  width: 220px;
  height: 220px;
  background: radial-gradient(circle, rgba(245, 165, 36, 0.08) 0%, transparent 70%);
}

.glow-bottom {
  bottom: -60px;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  height: 200px;
  background: radial-gradient(circle, rgba(229, 148, 25, 0.1) 0%, transparent 75%);
}

/* 极细弧线装饰 (暗金质感) */
.brand-ambient-rings {
  position: fixed;
  top: -60px;
  right: -60px;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  border: 1.5px dashed rgba(229, 148, 25, 0.1);
  pointer-events: none;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    top: 24px;
    left: 24px;
    right: 24px;
    bottom: 24px;
    border-radius: 50%;
    border: 1px solid rgba(229, 148, 25, 0.05);
  }
}

.app-main-content {
  position: relative;
  z-index: 1;
}
</style>
